module.exports = __webpack_public_path__ + "img/bo-fang.4fa4bf2b.png";